__turbopack_context__.v({
  "blink": "Gallery-module-scss-module__BLjPPq__blink",
  "gallery": "Gallery-module-scss-module__BLjPPq__gallery",
  "galleryImage": "Gallery-module-scss-module__BLjPPq__galleryImage",
  "swiper-slide": "Gallery-module-scss-module__BLjPPq__swiper-slide",
});
